// Lucian UX/UI Prompt #246 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#246
// 担当者別。期間や人を変えると、棒が伸び縮みしながら順位が入れ替わる（行は前の位置から滑って移る）。
// 1系列なので色は1つ（dataviz：名前の付いた項目に濃淡を付けない）。値は名前の横の数字で読める。
import React, { useRef } from 'react';
import { useFlip, usePrefersReducedMotion } from './motion';
import './lucian.css';

export default function RankBars({ rows, valueKey = 'acq', renderNums, renderSub, onPick, label }) {
  const reduced = usePrefersReducedMotion();
  const refs = useRef({});
  const sorted = [...rows].sort((a, b) => (b[valueKey] || 0) - (a[valueKey] || 0) || (b.seat || 0) - (a.seat || 0));
  const max = Math.max(...sorted.map(r => r[valueKey] || 0), 1);
  useFlip(sorted.map(r => String(r.user_id)), refs, { reduced });
  return (
    <div className="lx-rank" aria-label={label}>
      {sorted.map(r => (
        <button key={r.user_id} type="button" className="lx-rank__row"
          ref={el => { refs.current[String(r.user_id)] = el; }} onClick={() => onPick && onPick(r)}>
          <span className="lx-rank__name">{r.user_name || `#${r.user_id}`}</span>
          <span className="lx-rank__nums">{renderNums(r)}</span>
          <span className="lx-rank__bar" style={{ width: `${((r[valueKey] || 0) / max) * 100}%` }} aria-hidden="true" />
          {renderSub && <span className="lx-rank__sub">{renderSub(r)}</span>}
        </button>
      ))}
    </div>
  );
}
